import { stylesheet } from 'astroturf';
import styled from 'astroturf/react';
import Svg from 'src/components/Svg';
import TextField from 'src/components/TextField';
import Button from 'src/components/Button';

const Container = styled('div')`
  height: auto;
`;

const PopupInner = styled('div')`
  display: block;
`;

const AddTagIconBtn = styled(Svg)`
  height: 1em;
  width: 1em;
  border-radius: 50%;
  top: 0.25em;
  cursor: pointer;

  circle {
    fill: var(--ph-light-blue-500);
  }

  path {
    fill: var(--white);
  }
`;

const NewTagTextField = styled(TextField)`
  height: auto;
`;

const PopupFooter = styled('div').attrs(
  ({ isCreatingNewTag, ...props }) => {
    return {
      ...props,
      style: {
        position: 'relative',
        marginTop: isCreatingNewTag ? '7em' : '5em',
        marginBottom: '-1em',
        height: 'auto'
      }
    };
  })`
  display: block;
`;

const PopupFooterActionBar = styled('div')`
  display: flex;
  margin: 1em auto;
  align-items: center;
  justify-content: space-between;
`;

const LinkButton = styled(Button)`
  border-bottom: 0 !important;
`;

const Classes = stylesheet`
  .btn-cancel {
    cursor: pointer;
    color: var(--ph-gray-400);
  }

  .btn-save-and-apply:active {
    color: var(--ph-orange-500);
    background-color: var(--white);
  }

  .btn-save-and-apply[class*="disabled"] {
    color: var(--white);
    background-color: var(--ph-gray-300);
  }
`;

const RequiredTagsWrapper = styled('div')`
  margin-top: 4rem;
  strong {
    margin: 10px 0;
    display: block;
  }

  strong + div {
    margin-bottom: 15px;
  }
`;

const RequiredTag = styled('div')`
  cursor: pointer;
  transition: all 0.3s ease;
  user-select: none;

  &:hover {
    opacity: 0.5;
  }
`;

const TagsAddButton = styled(Button)`
  max-width: 400px;
  height: auto;
  text-align: left;
  white-space: normal;
`;

export default {
  AddTagIconBtn,
  Classes,
  Container,
  LinkButton,
  NewTagTextField,
  PopupInner,
  PopupFooter,
  PopupFooterActionBar,
  RequiredTag,
  RequiredTagsWrapper,
  TagsAddButton,
};
